import moment from 'moment';

export const DateFormat = (data) => moment(data).format('DD-MM-YYYY');

export const DateTimeFormat = (data) => moment(data).format('DD-MM-YYYY LT');

export const TimeFormat = (data) => moment(data).format('LT');

export const getCurrentYear = () => new Date().getFullYear();

export const MonthFormat = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const YearList = ['2023', '2024', '2025', '2026', '2027'];
